import { useEasterEggs } from 'features/permissions'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

export const TooltipContainer = styled.div`
  user-select: none;
  pointer-events: none;
  white-space: nowrap;
  border-radius: 0.25rem;
  padding: 1rem;
  max-width: 30vw;
  min-width: 20rem;
  background-color: ${({ theme }) => theme.forecast.background1};
  color: ${({ theme }) => theme.forecast.defaultText};
`
const BottomRightHelperText = styled.div`
  margin: 6px -8px -12px;
  font-family: sans-serif;
  font-style: italic;
  text-align: right;
  color: white;
`

export const VizTooltipContainer: React.FC<{
  isFrozen: boolean | undefined
  children: ReactNode
}> = ({ isFrozen, children }) => {
  const { isInternalAprilFools } = useEasterEggs()
  const helperText = React.useMemo(() => {
    if (isInternalAprilFools) return 'Press F to pay respects'
    return isFrozen ? 'Press F to unfreeze' : 'Press F to freeze'
  }, [isFrozen, isInternalAprilFools])

  return (
    <TooltipContainer>
      {children}
      <BottomRightHelperText data-html2canvas-ignore>
        {helperText}
      </BottomRightHelperText>
    </TooltipContainer>
  )
}
